import db from "./db";
/**
 * All the authz-related lookups that need to be relatively fast
 */ export const applicationIdFromPaywallId = async ({ paywallId })=>{
    let { applicationId } = await db.paywall.findUnique({
        where: {
            id: paywallId
        },
        select: {
            applicationId: true
        }
    }) || {};
    return applicationId;
};
export const organizationIdFromProjectId = async ({ projectId })=>{
    let { organizationId } = await db.project.findUnique({
        where: {
            id: projectId
        },
        select: {
            organizationId: true
        }
    }) || {};
    return organizationId;
};
export const applicationIdFromSurveyId = async ({ surveyId })=>{
    let { applicationId } = await db.survey.findUnique({
        where: {
            id: surveyId
        },
        select: {
            applicationId: true
        }
    }) || {};
    return applicationId;
};
export const applicationIdFromWebPaywallId = async ({ webPaywallId })=>{
    let { applicationId } = await db.webPaywall.findUnique({
        where: {
            id: webPaywallId
        },
        select: {
            applicationId: true
        }
    }) || {};
    return applicationId;
};
export const applicationIdFromWebPaywallTriggerId = async ({ webPaywallTriggerId })=>{
    let { applicationId } = await db.webPaywallTrigger.findUnique({
        where: {
            id: webPaywallTriggerId
        },
        select: {
            applicationId: true
        }
    }) || {};
    return applicationId;
};
export const applicationIdFromWebProductId = async ({ webProductId })=>{
    let { applicationId } = await db.webProduct.findUnique({
        where: {
            id: webProductId
        },
        select: {
            applicationId: true
        }
    }) || {};
    return applicationId;
};
export const notificationTimelineIdFromNotificationNodeId = async ({ notificationNodeId })=>{
    let { notificationTimelineId } = await db.notificationNode.findUnique({
        where: {
            id: notificationNodeId
        },
        select: {
            notificationTimelineId: true
        }
    }) || {};
    return notificationTimelineId;
};
export const notificationNodeIdFromNotificationPlanId = async ({ notificationPlanId })=>{
    let { notificationNodeId } = await db.notificationPlan.findUnique({
        where: {
            id: notificationPlanId
        },
        select: {
            notificationNodeId: true
        }
    }) || {};
    return notificationNodeId;
};
export const applicationIdFromapplicationWebhookDestinationId = async ({ applicationWebhookDestinationId })=>{
    let { applicationId } = await db.applicationWebhookDestination.findUnique({
        where: {
            id: applicationWebhookDestinationId
        },
        select: {
            applicationId: true
        }
    }) || {};
    return applicationId;
};
export const applicationIdFromNotificationTimelineId = async ({ notificationTimelineId })=>{
    let { applicationId } = await db.notificationTimeline.findUnique({
        where: {
            id: notificationTimelineId
        },
        select: {
            applicationId: true
        }
    }) || {};
    return applicationId;
};
export const applicationIdFromNotificationTimelineV2Id = async ({ notificationTimelineV2Id })=>{
    let { applicationId } = await db.notificationTimelineV2.findUnique({
        where: {
            id: notificationTimelineV2Id
        },
        select: {
            applicationId: true
        }
    }) || {};
    return applicationId;
};
export const notificationTimelineV2IdFromNotificationNodeV2Id = async ({ notificationNodeV2Id })=>{
    let { notificationTimelineV2Id } = await db.notificationNodeV2.findUnique({
        where: {
            id: notificationNodeV2Id
        },
        select: {
            notificationTimelineV2Id: true
        }
    }) || {};
    return notificationTimelineV2Id;
};
export const applicationIdFromProductId = async ({ productId })=>{
    let { applicationId } = await db.product.findUnique({
        where: {
            id: productId
        },
        select: {
            applicationId: true
        }
    }) || {};
    return applicationId;
};
export const applicationIdFromExperimentId = async ({ experimentId })=>{
    let { applicationId } = await db.experiment.findUnique({
        where: {
            id: experimentId
        },
        select: {
            applicationId: true
        }
    }) || {};
    return applicationId;
};
export const applicationIdFromExperimentGroupId = async ({ experimentGroupId })=>{
    let { applicationId } = await db.triggerExperimentGroup.findUnique({
        where: {
            id: experimentGroupId
        },
        select: {
            applicationId: true
        }
    }) || {};
    return applicationId;
};
export const applicationIdIdFromPaywallTriggerExperimentId = async ({ paywallTriggerExperimentId })=>{
    const triggerExperiment = await db.triggerExperiment.findUnique({
        where: {
            id: paywallTriggerExperimentId
        },
        select: {
            triggerExperimentGroup: {
                select: {
                    applicationId: true
                }
            }
        }
    });
    return triggerExperiment?.triggerExperimentGroup?.applicationId;
};
export const applicationIdFromTriggerExperimentGroupId = async ({ triggerExperimentGroupId })=>{
    let { applicationId } = await db.triggerExperimentGroup.findUnique({
        where: {
            id: triggerExperimentGroupId
        },
        select: {
            applicationId: true
        }
    }) || {};
    return applicationId;
};
export const experimentIdFromVariantId = async ({ variantId })=>{
    let { experimentId } = await db.variant.findUnique({
        where: {
            id: variantId
        },
        select: {
            experimentId: true
        }
    }) || {};
    return experimentId;
};
export const applicationIdFromVariantId = async ({ variantId })=>{
    const experimentId = await experimentIdFromVariantId({
        variantId
    });
    return await applicationIdFromExperimentId({
        experimentId: experimentId
    });
};
export const applicationIdFromPaywallTriggerId = async ({ paywallTriggerId })=>{
    let { applicationId } = await db.paywallTrigger.findUnique({
        where: {
            id: paywallTriggerId
        },
        select: {
            applicationId: true
        }
    }) || {};
    return applicationId;
};
export const organizationIdFromApplicationId = async ({ applicationId })=>{
    let { organizationId } = await db.application.findUnique({
        where: {
            id: applicationId
        },
        select: {
            organizationId: true
        }
    }) || {};
    return organizationId;
};
export const organizationIdFromMembershipId = async ({ membershipId })=>{
    let { organizationId } = await db.membership.findUnique({
        where: {
            id: membershipId
        },
        select: {
            organizationId: true
        }
    }) || {};
    return organizationId;
};
export const userHasOrganizationMembership = async ({ userId, organizationId })=>{
    if (userId === null) {
        return undefined;
    }
    const membership = await db.membership.findFirst({
        where: {
            userId,
            organizationId
        },
        select: {
            role: true
        },
        take: 1
    });
    return membership?.role;
};
export const paywallTemplateTypeFromPaywallId = async ({ paywallId })=>{
    let { templateType } = await db.paywall.findUnique({
        where: {
            id: paywallId
        },
        select: {
            templateType: true
        }
    }) || {};
    return templateType;
};
